// 获取群组信息
import { getGroupInfo } from '@/api/workPlace/workOrder'
import store from '@/store'
import { get } from 'lodash'
import moment from 'moment'
import { computed } from 'vue'
import _ from 'lodash'

export default function getCurrentGroupInfo() {
  const chartId = computed(() => store.state.workOrder.chartId)
  const groupId = chartId.value
  const res = {}
  return new Promise(resolve => {
    if (!groupId) resolve(null)
    getGroupInfo({ groupId })
      .then(data => {
        const ucUserId = computed(() => store.getters.userInfo.ucUserId)
        const {
          groupType,
          groupId,
          doctorInfo,
          doctorAssistantInfos,
          assistantInfos,
          bindAssistant,
          patientInfo
        } = data.groupInfo
        data.groupInfo.doctorInfo = doctorInfo || {}
        data.groupInfo.doctorAssistantInfos = doctorAssistantInfos || []
        data.groupInfo.assistantInfos = assistantInfos || []
        data.groupInfo.bindAssistant = bindAssistant || {}
        data.groupInfo.patientInfo = patientInfo || {}

        // 当前bd
        const curBdInfo = assistantInfos.find(item => !item.deleteFlag) || {}
        //当前健管
        const curDocAss = doctorAssistantInfos.find(item => item.ucUserId == ucUserId.value) || {}
        data.groupInfo.curBdInfo = curBdInfo
        data.groupInfo.curDocAss = curDocAss

        res.workOrderGroupInfo = data.groupInfo
        res.workOrderGroupInfo.groupWorkOrderList = data.groupWorkOrderList || []
        res.workOrderGroupInfo.dealWorkOrderList = data.dealWorkOrderList || []
        res.workOrderGroupInfo.tipMessage = data.tipMessage
        // 私聊 id
        res.workOrderGroupInfo.assistantPatientGroupId = data.assistantPatientGroupId
        res.workOrderGroupInfo.doctorDaGroupId = data.doctorDaGroupId
        // 三方群聊 id
        res.workOrderGroupInfo.doctorPatientGroupId = data.doctorPatientGroupId
        const { patientRemark, hospitalName, doctorDepartmentName, bdDepartmentName } =
          data.groupInfo
        if (JSON.stringify(res.workOrderGroupInfo.bindAssistant) !== '{}') {
          res.workOrderGroupInfo.bindAssistant.bdDepartmentName = bdDepartmentName
        }
        if (JSON.stringify(res.workOrderGroupInfo.patientInfo) !== '{}') {
          res.workOrderGroupInfo.patientInfo.patientRemark = patientRemark
        }
        if (JSON.stringify(res.workOrderGroupInfo.doctorInfo) !== '{}') {
          res.workOrderGroupInfo.doctorInfo.hospitalName = hospitalName
          res.workOrderGroupInfo.doctorInfo.doctorDepartmentName = doctorDepartmentName
        }
        let targetWorkOrder = {}
        try {
          // 取当前关联工单里面最新的一个工单
          const { dealWorkOrderList } = data
          const list = _.cloneDeep(dealWorkOrderList || [])
          if (list && list.length) {
            const targetWorkOrderList = list.sort((a, b) => {
              return moment(b.createAt).valueOf() - moment(a.createAt).valueOf()
            })
            targetWorkOrder = targetWorkOrderList[0] || {}
          }
        } catch {
          targetWorkOrder = {}
        }

        const info = {
          ucDoctorId: get(data, 'groupInfo.doctorInfo.ucUserId', null),
          ucDoctorName: get(data, 'groupInfo.doctorInfo.username', ''),
          ucPatientId: get(data, 'groupInfo.patientInfo.ucUserId', null),
          ucPatientName: get(data, 'groupInfo.patientInfo.username', ''),
          serialNumber: targetWorkOrder.serialNumber || undefined,
          activityFlag: targetWorkOrder.activityFlag || null // 临观标识
        }
        res.workOrderGroupInfo.targetWorkOrder = targetWorkOrder
        sessionStorage.setItem('CURRENT_WORKORDER_INFO', JSON.stringify(info))
        store.commit('workOrder/SET_GROUP_INFO', res.workOrderGroupInfo)
        store.commit('workOrder/SET_ISGUIDE_CONSULT')
        if (groupType === 3) {
          // 判断是不是导诊咨询工单
          store.commit('workOrder/SET_ISGUIDE_CONSULT', true)
          res.workOrderGroupInfo.guideConsultGroupId = data.medicalGuideGroupId
        } else if (groupType === 4) {
          //BD协助工单
          res.workOrderGroupInfo.doctorDaGroupId = groupId
          res.workOrderGroupInfo.groupId = ''
        }
        // 导诊ID不在区分群类型
        res.workOrderGroupInfo.guideConsultGroupId = data.medicalGuideGroupId || null
        resolve(res)
      })
      // FIXME:清除当前会话信息 和 所有会话的id
      .catch(() => {
        store.commit('workOrder/SET_CHART_ID')
        store.commit('workOrder/SET_GROUP_INFO')
        store.commit('workOrder/SET_ISGUIDE_CONSULT')
        resolve(null)
      })
    //   .finally(() => {
    //     res = JSON.stringify(res) === '{}' ? null : res
    //     cb && cb(res)
    //   })
  })
}
